export enum TaskQuickFilter {
  ALL_TASKS = "all_tasks",
  MY_TASKS = "my_tasks",
  ASSIGNED_TO_ME = "assigned_to_me",
  CREATED_BY_ME = "created_by_me",
}

export enum TaskView {
  KANBAN = "kanban",
  LIST = "list",
  TABLE = "table",
  TIME = "time",
}
